export default new class Pagination {
    constructor() {
        this.pagination = '[data-pagination]';

        if (!$(this.pagination).length) return;

        this.conf = {
            scrollTopSpeed: 700
        };

        this.paginationLink = '[data-pagination-link]';
        this.categorySort = '[data-category-sort]';
        this.categorySortBtn = '[data-category-sort-btn]';
        this.categoryFilters = '[data-category-filters]';
        this.categoryFiltersItem = '[data-category-filters-item]';
        this.categoryFiltersListItem = '[data-category-filters-list-item]';

        this.categoryPage = '[data-category]';
        this.searchPage = '[data-search-page]';
        this.preloader = '[data-preloader]';

        this.classActive = '_active';
        this.classMobile = '_mobile';
        this.classShow = '_show';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.paginationLink, (e) => {
            e.preventDefault();
            this.collectData($(e.currentTarget));
            $(this.preloader).addClass(this.classShow)
        })
    }

    collectData($link) {
        let categoryID = $(this.categoryPage).data('category-id'),
            data = {},
            url = '',
            update = {};

        if ($(this.searchPage).length) {
            data = {
                sort: this.defineSortType(),
                page: this.definePage($link)
            };
            url = 'onSearchUpdate';
            update = {'search/search-list':'.search__list-wrap', 'pagination/pagination':'.pagination_updateable'};
        } else {
            data = {
                filters: this.collectFilterData(),
                sort: this.defineSortType(),
                page: this.definePage($link),
                category_id: categoryID
            };
            url = 'onUpdate';
            update = {'category/products-list':'.category__list-wrap', 'pagination/pagination':'.pagination_updateable'};
        }
        this.sendData(data,url,update)
    }

    definePage($link) {
        let page;

        if ($link.text() === 'Далее') {
            $(this.paginationLink).each((i, item) => {
                if ($(item).hasClass(this.classActive)) {
                    page = parseInt($(item).text()) + 1;
                }
            })
        } else if($link.text() === 'Назад') {
            $(this.paginationLink).each((i, item) => {
                if ($(item).hasClass(this.classActive)) {
                    page = parseInt($(item).text()) - 1;
                }
            })
        } else {
            page = parseInt($link.text());
        }

        return page;
    }

    defineSortType() {

        let $categorySort = this.detectFilter(this.categorySort),
            sortType;

        $categorySort.find(this.categorySortBtn).each((i, item) => {
            if ($(item).hasClass(this.classActive)) {
                sortType = $(item).data('category-sort-btn')
            }
        });

        return sortType;
    }

    detectFilter(selector) {
        let curFilter = $(selector).map((i, item) => {
            if (this.isMobile()) {
                if ($(item).hasClass(this.classMobile)) {
                    return item;
                }
            } else {
                if (!$(item).hasClass(this.classMobile)) {
                    return item;
                }
            }
        });

        return curFilter;
    }

    collectFilterData() {
        let obj = {},
            arFilters,
            $categoryFilters = this.detectFilter(this.categoryFilters);

        arFilters = $categoryFilters.find(this.categoryFiltersItem);

        arFilters.each((i, item) => {
            obj[$(item).data('category-filters-item')] = this.collectSelectedCheckboxes($(item));
        });
        return obj;
    }

    collectSelectedCheckboxes($filter) {
        let arr = [];

        $filter.find(this.categoryFiltersListItem).each((i, item) => {
            if ($(item).prop('checked') === true) {
                arr.push($(item).attr('name'))
            }
        });

        return arr;
    }

    isMobile() {
        return $(window).width() < 768
    }

    sendData(data,url,update) {
        let Pagination = this; // do not delete this variable, Denis!

        $.request(url, {
            update: update,
            data: {'data': data},
            complete: function (response) {
                $(Pagination.preloader).removeClass(Pagination.classShow);
                $('html, body').animate({
                    scrollTop: 0
                }, Pagination.conf.scrollTopSpeed)
            }
        })
    }
}
